import React from 'react';

const GuestContext = React.createContext({ isGuest: false, allowedPages: [], exists: true });

export default GuestContext;


